import React from 'react';
import withIcon from '../utilities/withIcon';

const IconTruck = () => {
  return (
    <g>
      <path d="m8.001 1 6.95.009c.541 0 .986.41 1.043.936L16 2.06v10.388c0 .542-.41.988-.936 1.045l-.114.006h-1.328a2.251 2.251 0 0 1-4.244 0H6.872a2.251 2.251 0 0 1-4.244 0H1.05a1.05 1.05 0 0 1-1.044-.936L0 12.448V7.995c0-.138.037-.267.102-.378l2.584-4.495c.288-.5.8-.823 1.368-.872l.156-.006 3.04.012V1.75a.75.75 0 0 1 .65-.743L8 1zM4.75 11.998a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5zm6.75 0a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5zM8.75 2.501v5.494a.75.75 0 0 1-.648.744L8 8.746H1.5v3.252h1.128a2.251 2.251 0 0 1 4.247.01h2.5a2.251 2.251 0 0 1 4.247-.01h.878V2.51l-5.75-.008zM4.204 3.745a.25.25 0 0 0-.177.073l-.04.053-1.94 3.373 5.203.001V3.757l-3.046-.012z" />
    </g>
  );
};

export default withIcon(IconTruck);
